import Swal from 'sweetalert2';
import { RemoteConstants } from '../../data/remote/RemoteConstants';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { errorManager } from '../../presentation/utils/errorManager';

/* eslint-disable no-unused-vars */
export const sessionEnd = async (token, usuario, dispatch) => {
  try {
    const params = new URLSearchParams({
      token: token,
      uid: usuario
    });
    const peticion = await fetch(`${RemoteConstants.BASE_URL}pin/delete/app/session?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(resp => {
        return resp.json();
      })
      .then(data => {
        if (data.data === 1) {
          Swal.fire('¡Hecho!', data.userMessage, 'success');
        } else if (data.data === 0) {
          Swal.fire('Error', 'No hay sesión activa para este usuario', 'error');
        } else {
          errorManager(data.userMessage);
        }
      });
  } catch (error) {
    errorManager(error);
  }
  dispatch(UIActions.uiLoadInactive());
}